// The tooltip's pure half — 05j-1. tooltip.js's two placements, copied exactly: over an
// element (a `data-tooltip` hover) and at a point (the canvas / SVG widgets that hit-test
// themselves). Both keep 8px off the viewport's sides and flip when there's no room.

export interface Box {
  left: number;
  top: number;
  width: number;
  height: number;
}

const GAP = 8;

const clampLeft = (left: number, width: number, viewportW: number) => Math.max(GAP, Math.min(left, viewportW - width - GAP));

/** Centred above the element; below it (flipped) when it would go off the top. */
export function tooltipOverElement(
  el: Box,
  tip: { width: number; height: number },
  viewportW: number,
): { left: number; top: number; flipped: boolean } {
  let top = el.top - tip.height - GAP;
  let flipped = false;
  if (top < GAP) {
    top = el.top + el.height + GAP;
    flipped = true;
  }
  return { left: clampLeft(el.left + el.width / 2 - tip.width / 2, tip.width, viewportW), top, flipped };
}

/** Centred on the point: above it by default (below if no room); `below` asks for the
 *  opposite priority (Shot / Pass Map's hover), above if no room. */
export function tooltipAtPoint(
  x: number,
  y: number,
  tip: { width: number; height: number },
  viewport: { width: number; height: number },
  position?: string,
): { left: number; top: number } {
  let top: number;
  if (position === "below") {
    top = y + GAP;
    if (top + tip.height > viewport.height - GAP) top = y - tip.height - GAP;
  } else {
    top = y - tip.height - GAP;
    if (top < GAP) top = y + GAP;
  }
  return { left: clampLeft(x - tip.width / 2, tip.width, viewport.width), top };
}
